import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ContentForm from "./ContentForm";

function ContentWrite() {
  const navigate = useNavigate();
  const { category = "notice" } = useParams();

  useEffect(() => {
    if (category === "calendar") {
      navigate("/stdcounciladmin/adminhome/contents/calendar", {
        replace: true,
      });
    }
  }, [category, navigate]);

  const handleListMove = () => {
    navigate(`/stdcounciladmin/adminhome/contents/${category}`, {
      replace: true,
    });
  };

  if (category === "calendar") {
    return null;
  }

  return (
    <ContentForm
      mode="write"
      category={category}
      onCancel={handleListMove}
      onSaveComplete={handleListMove}
    />
  );
}

export default ContentWrite;